import { QueryClientProvider } from "@tanstack/react-query";
import CssBaseline from "@mui/material/CssBaseline";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { appRoutes } from "./AppRoutes";
import { ThemeProvider } from "@mui/material";
import { useUserTheme } from "./state/preferencesStore";
import { ErrorBoundary } from "./components/ErrorBoundary";
import i18n from "./i18n";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { setDefaultOptions } from "date-fns";
import { getLocale } from "./components/getLocale";
import { createQueryClient } from "./createQueryClient";

const queryClient = createQueryClient();
const router = createBrowserRouter(appRoutes, {});

export function App() {
  const { theme, hydrated } = useUserTheme();

  // Language is not synced here: it is a per-user server setting applied by
  // useLanguagePreference inside the authenticated layout. Before sign-in, i18next's
  // own detector decides.

  // Avoid theme flicker until we know the user's save2d preference
  if (!hydrated) return null;

  const locale = getLocale(i18n.language);
  setDefaultOptions({ locale });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary>
            <RouterProvider router={router} />
          </ErrorBoundary>
        </QueryClientProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
